import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, Award, Users, Building, Clock, BookOpen, ArrowRight } from 'lucide-react';
import SchoolLogo from '../images/logo.jpg';
import '../styles/About.scss';

const AboutSchool = () => {
  const { t } = useTranslation();

  const schoolHighlights = [
    { icon: <Building className="highlight-icon" />, title: t('highlight_gov_affil'), description: t('highlight_gov_affil_desc') },
    { icon: <Clock className="highlight-icon" />, title: t('highlight_30_years'), description: t('highlight_30_years_desc') },
    { icon: <Users className="highlight-icon" />, title: t('highlight_holistic'), description: t('highlight_holistic_desc') },
    { icon: <BookOpen className="highlight-icon" />, title: t('highlight_modern_curr'), description: t('highlight_modern_curr_desc') },
    { icon: <Globe className="highlight-icon" />, title: t('highlight_lang_culture'), description: t('highlight_lang_culture_desc') },
    { icon: <Award className="highlight-icon" />, title: t('highlight_100_awards'), description: t('highlight_100_awards_desc') },
  ];

  return (
    <section className="about-school-section">
      <svg className="about-deco" viewBox="0 0 120 120" fill="none" aria-hidden="true">
        <circle cx="60" cy="60" r="55" stroke="currentColor" strokeWidth="2" opacity=".1" />
        <ellipse cx="60" cy="60" rx="30" ry="55" stroke="currentColor" strokeWidth="1.5" opacity=".08" />
        <line x1="5" y1="60" x2="115" y2="60" stroke="currentColor" strokeWidth="1.5" opacity=".08" />
        <line x1="5" y1="40" x2="115" y2="40" stroke="currentColor" strokeWidth="1" opacity=".06" />
        <line x1="5" y1="80" x2="115" y2="80" stroke="currentColor" strokeWidth="1" opacity=".06" />
      </svg>

      <div className="about-school-container">
        <div className="about-section-tag">{t('about_prabhat_tara_tag')}</div>

        <div className="school-intro">
          <div className="school-logo-container">
            <img src={SchoolLogo} alt={`${t('school_name')} Logo`} className="school-logo" loading="lazy" />
          </div>

          <div className="school-description">
            <h2>{t('school_name')}</h2>
            <p className="school-tagline">{t('about_school_tagline')}</p>
            <p className="school-mission">
              {t('about_school_mission')}
            </p>
            <a href="/about-us" className="about-cta">
              <span>{t('read_our_full_story')}</span>
              <ArrowRight size={16} />
            </a>
          </div>
        </div>

        <div className="school-highlights">
          {schoolHighlights.map((highlight, index) => (
            <div key={index} className="highlight-item">
              <div className="icon-squircle">
                {highlight.icon}
              </div>
              <h3>{highlight.title}</h3>
              <p>{highlight.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSchool;
